import { render, staticRenderFns } from "./PopupProducts.vue?vue&type=template&id=52f5e5fe"
import script from "./PopupProducts.vue?vue&type=script&lang=js"
export * from "./PopupProducts.vue?vue&type=script&lang=js"
import style0 from "./PopupProducts.vue?vue&type=style&index=0&id=52f5e5fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports